<template>
  <div id="product">
    <Breadcrumb />
    <p class="sub-title prl70">Select Style</p>
    <div class="content middle collect mb50">
      <div class="cell">
        <!--  Start -->
        <div v-if="1">
          <div class="container font14 dflex" :class="{fcolumn: $store.getters.isVertical, frow: !$store.getters.isVertical}">
            <div class="row">
              <div class="col-xs-12 text-center mt30 inlineb mb30">
                <div class="inlineb p10 w100">
                  <div ref="printMe" class="inlineb">
                    <AlbaPanel v-if="type == 'alba'" />
                    <AriaPanel v-else-if="type == 'aria'" />
                    <AxesPanel v-else-if="type == 'axes'" />
                    <BlackJackPanel v-else-if="type == 'blackjack'" />
                  </div>
                </div>
              </div>
            </div>

            <div class="row prl70" :class="{pt100 : $store.getters.isVertical}">
              <div
                class="text-center prl0"
                :class="'col-xs-' + 12 / $store.getters.divider"
              >
                <div>
                  <p class="mt20 mb20" v-if="format != 'single'">{{ label1 }}</p>

                  <el-radio
                    v-for="item in styleSet[type][layout]"
                    :key="item.label"
                    v-model="layoutStyle"
                    :label="item.label"
                  >
                    <div class="inlineb mlr5 w72">
                      <div class="border inlineb svgb">
                        <i class="iconfont3" :class="item.img"></i>
                      </div>
                      <p class="name-f">
                        {{ item.title }}
                      </p>
                    </div>
                  </el-radio>
                </div>
              </div>
              <div
                class="text-center prl0"
                :class="{['col-xs-' + 12 / $store.getters.divider] : true,
                'bdr-d' : !$store.getters.isVertical, 'bdrt-d' : $store.getters.isVertical}"
                v-if="format != 'single'"
              >
                <div>
                  <p class="mt20 mb20">{{ label2 }}</p>
                  <el-radio
                    v-for="item in styleSet[type][rightLayout]"
                    :key="item.label"
                    v-model="rightLayoutStyle"
                    :label="item.label"
                  >
                    <div class="mlr5 inlineb w72">
                      <div class="border inlineb svgb">
                        <i class="iconfont3" :class="item.img"></i>
                      </div>
                      <p class="name-f">
                        {{ item.title }}
                      </p>
                    </div>
                  </el-radio>
                </div>
              </div>
              <div
                class="text-center prl0"
                :class="{['col-xs-' + 12 / $store.getters.divider] : true,
                'bdr-d' : !$store.getters.isVertical, 'bdrt-d' : $store.getters.isVertical}"
                v-if="$store.getters.isTriple"
              >
                <div>
                  <p class="mt20 mb20">{{ label3 }}</p>
                  <el-radio
                    v-for="item in styleSet[type][tripleRightLayout]"
                    :key="item.label"
                    v-model="tripleRightLayoutStyle"
                    :label="item.label"
                  >
                    <div class="mlr5 inlineb w72">
                      <div class="border inlineb svgb">
                        <i class="iconfont3" :class="item.img"></i>
                      </div>
                      <p class="name-f">
                        {{ item.title }}
                      </p>
                    </div>
                  </el-radio>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="nav-footer white font16">
      <span class="white click inlineb w10" @click="restart()">
        <i class="iconfont3 icon-reset"></i> RESTART
      </span>
      <span class="white click inlineb w10" @click="back()">
        <i class="iconfont3 icon-back"></i> BACK
      </span>

      <span class="orange click inlineb w10" @click="next()">
        NEXT <i class="iconfont3 icon-next"></i>
      </span>
    </div>
  </div>
</template>

<script>
import "@/assets/css/project.css";
import Breadcrumb from "./Panel/Breadcrumb";
import AlbaPanel from "./Panel/AlbaPanel";
import AriaPanel from "./Panel/AriaPanel";
import AxesPanel from "./Panel/AxesPanel";
import BlackJackPanel from "./Panel/BlackJackPanel";
import artworkToProductMixin from "../../mixins/artworkToProductMixin";

export default {
  name: "s2",
  components: {
    Breadcrumb,
    AlbaPanel,
    AriaPanel,
    AxesPanel,
    BlackJackPanel
  },
  data() {
    return {
      type: null,
      format: null,
      layout: null,
      rightLayout: null,
      tripleRightLayout: null,
      styleSet: {
        alba: {
          K2: [
            { label: "iconOnly", title: "Icon Only", img: "icon-icon-medium" },
            {
              label: "singleLineText",
              title: "Single Line Text",
              img: "icon-alba-t1",
            },
            {
              label: "doubleLineText",
              title: "Double Line Text",
              img: "icon-alba-t",
            },
            {
              label: "iconSingleLineText",
              title: "Icon + Single Line Text",
              img: "icon-alba-it1",
            },
            {
              label: "iconDoubleLineText",
              title: "Icon + Double Line Text",
              img: "icon-alba-it",
            },
          ],

          K4: [
            { label: "iconOnly", title: "Icon Only", img: "icon-icon-medium" },
            {
              label: "singleLineText",
              title: "Single Line Text",
              img: "icon-alba-t1",
            },
            {
              label: "doubleLineText",
              title: "Double Line Text",
              img: "icon-alba-t",
            },
            {
              label: "iconSingleLineText",
              title: "Icon + Single Line Text",
              img: "icon-alba-it1",
            },
            {
              label: "iconDoubleLineText",
              title: "Icon + Double Line Text",
              img: "icon-alba-it",
            },
          ],

          K8: [
            { label: "iconOnly", title: "Icon Only", img: "icon-icon-medium" },
            {
              label: "singleLineText",
              title: "Single Line Text",
              img: "icon-alba-t1",
            },
            {
              label: "doubleLineText",
              title: "Double Line Text",
              img: "icon-alba-t",
            },
            {
              label: "iconSingleLineText",
              title: "Icon + Single Line Text",
              img: "icon-alba-it1",
            },
            {
              label: "iconDoubleLineText",
              title: "Icon + Double Line Text",
              img: "icon-alba-it",
            },
          ],

          M1: [
            { label: "iconOnly", title: "Icon Only", img: "icon-icon-medium" },
            {
              label: "singleLineText",
              title: "Single Line Text",
              img: "icon-alba-t1",
            },
            {
              label: "doubleLineText",
              title: "Double Line Text",
              img: "icon-alba-t",
            },
            {
              label: "iconSingleLineText",
              title: "Icon + Single Line Text",
              img: "icon-alba-it1",
            },
            {
              label: "iconDoubleLineText",
              title: "Icon + Double Line Text",
              img: "icon-alba-it",
            },
          ],
        },
        aria: {
          L12: [
            { label: "iconOnly", title: "Icon Only", img: "icon-aria-ti1" },
            {
              label: "singleLineText",
              title: "Single Line Text",
              img: "icon-aria-t",
            },
            {
              label: "doubleLineText",
              title: "Double Line Text",
              img: "icon-aria-at",
            },
            {
              label: "iconSingleLineTextMid",
              title: "Icon + Single Line Text (Middle)",
              img: "icon-aria-it-m",
            },
            {
              label: "iconDoubleLineTextMid",
              title: "Icon + Double Line Text (Middle)",
              img: "icon-aria-ti",
            },
            {
              label: "iconSingleLineText",
              title: "Icon + Single Line Text",
              img: "icon-aria-itu",
            },
            {
              label: "iconDoubleLineText",
              title: "Icon + Double Line Text",
              img: "icon-aria-it",
            },
          ],
          M1: [
            { label: "iconOnly", title: "Icon Only", img: "icon-icon-medium" },
            {
              label: "singleLineText",
              title: "Single Line Text",
              img: "icon-alba-t1",
            },
            {
              label: "doubleLineText",
              title: "Double Line Text",
              img: "icon-alba-t",
            },
            {
              label: "iconSingleLineText",
              title: "Icon + Single Line Text",
              img: "icon-alba-it1",
            },
            {
              label: "iconDoubleLineText",
              title: "Icon + Double Line Text",
              img: "icon-alba-it",
            },
          ],
          SK: []
        },
        axes: {
          L9: [
            { label: "iconOnly", title: "Icon Only", img: "icon-aria-ti1" },
            {
              label: "singleLineText",
              title: "Single Line Text",
              img: "icon-aria-t",
            },
            {
              label: "doubleLineText",
              title: "Double Line Text",
              img: "icon-aria-at",
            },
            {
              label: "iconSingleLineTextMid",
              title: "Icon + Single Line Text (Middle)",
              img: "icon-aria-it-m",
            },
            {
              label: "iconDoubleLineTextMid",
              title: "Icon + Double Line Text (Middle)",
              img: "icon-aria-ti",
            },
            {
              label: "iconSingleLineText",
              title: "Icon + Single Line Text",
              img: "icon-aria-itu",
            },
            {
              label: "iconDoubleLineText",
              title: "Icon + Double Line Text",
              img: "icon-aria-it",
            },
          ],
          TT: [
            { label: "iconOnly", title: "Icon Only", img: "icon-aria-ti1" },
            {
              label: "singleLineText",
              title: "Single Line Text",
              img: "icon-aria-t",
            },
            {
              label: "doubleLineText",
              title: "Double Line Text",
              img: "icon-aria-at",
            },
            {
              label: "iconSingleLineText",
              title: "Icon + Single Line Text",
              img: "icon-aria-itu",
            },
            {
              label: "iconDoubleLineText",
              title: "Icon + Double Line Text",
              img: "icon-aria-it",
            },
          ],
          CR: [
            { label: "iconOnly", title: "Icon Only", img: "icon-aria-ti1" },
            {
              label: "singleLineText",
              title: "Single Line Text",
              img: "icon-aria-t",
            },
            {
              label: "doubleLineText",
              title: "Double Line Text",
              img: "icon-aria-at",
            },
            {
              label: "iconSingleLineText",
              title: "Icon + Single Line Text",
              img: "icon-aria-itu",
            },
            {
              label: "iconDoubleLineText",
              title: "Icon + Double Line Text",
              img: "icon-aria-it",
            },
          ],
          CH: [
            { label: "iconOnly", title: "Icon Only", img: "icon-aria-ti1" },
            {
              label: "singleLineText",
              title: "Single Line Text",
              img: "icon-aria-t",
            },
            {
              label: "doubleLineText",
              title: "Double Line Text",
              img: "icon-aria-at",
            },
            {
              label: "iconSingleLineText",
              title: "Icon + Single Line Text",
              img: "icon-aria-itu",
            },
            {
              label: "iconDoubleLineText",
              title: "Icon + Double Line Text",
              img: "icon-aria-it",
            },
          ],

          DR: [],

          KN: [
            { label: "iconOnly", title: "Icon Only", img: "icon-aria-ti1" },
            {
              label: "singleLineText",
              title: "Single Line Text",
              img: "icon-aria-t",
            },
            {
              label: "doubleLineText",
              title: "Double Line Text",
              img: "icon-aria-at",
            },
            {
              label: "iconSingleLineText",
              title: "Icon + Single Line Text",
              img: "icon-aria-itu",
            },
            {
              label: "iconDoubleLineText",
              title: "Icon + Double Line Text",
              img: "icon-aria-it",
            },
          ],
          N2: [
            { label: "iconOnly", title: "Icon Only", img: "icon-aria-ti1" },
            {
              label: "singleLineText",
              title: "Single Line Text",
              img: "icon-aria-t",
            },
            {
              label: "doubleLineText",
              title: "Double Line Text",
              img: "icon-aria-at",
            },
            {
              label: "iconSingleLineText",
              title: "Icon + Single Line Text",
              img: "icon-aria-itu",
            },
            {
              label: "iconDoubleLineText",
              title: "Icon + Double Line Text",
              img: "icon-aria-it",
            },
          ],
          N34: [
            { label: "iconOnly", title: "Icon Only", img: "icon-aria-ti1" },
            {
              label: "singleLineText",
              title: "Single Line Text",
              img: "icon-aria-t",
            },
            {
              label: "doubleLineText",
              title: "Double Line Text",
              img: "icon-aria-at",
            },
            {
              label: "iconSingleLineText",
              title: "Icon + Single Line Text",
              img: "icon-aria-itu",
            },
            {
              label: "iconDoubleLineText",
              title: "Icon + Double Line Text",
              img: "icon-aria-it",
            },
          ],
          N35: [
            { label: "iconOnly", title: "Icon Only", img: "icon-aria-ti1" },
            {
              label: "singleLineText",
              title: "Single Line Text",
              img: "icon-aria-t",
            },
            {
              label: "doubleLineText",
              title: "Double Line Text",
              img: "icon-aria-at",
            },
            {
              label: "iconSingleLineText",
              title: "Icon + Single Line Text",
              img: "icon-aria-itu",
            },
            {
              label: "iconDoubleLineText",
              title: "Icon + Double Line Text",
              img: "icon-aria-it",
            },
          ],
          SK : []
        },
        blackjack: {
          K2: [
            { label: "iconOnly", title: "Icon Only", img: "icon-icon-medium" }
          ],
          K4: [
            { label: "iconOnly", title: "Icon Only", img: "icon-icon-medium" }
          ],
          K6: [
            { label: "iconOnly", title: "Icon Only", img: "icon-icon-medium" }
          ],
          K8: [
            { label: "iconOnly", title: "Icon Only", img: "icon-icon-medium" }
          ],
          M1: [
            { label: "iconOnly", title: "Icon Only", img: "icon-icon-medium" }
          ],
        },
      },

    }
  },
  mixins: [artworkToProductMixin],
  methods: {
    restart() {
      this.$confirm("Are you sure you want to restart?", "Warning", {
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        type: "warning",
      }).then(() => {
        this.$router.push({ path: "/collection" });
      });
    },

    next() {
      this.$store.commit("getProductCode");
      //Go to next page
      this.$router.push({ path: "/collection/engraving/" + this.routeParamArtworkId});
    },
    back() {
      this.$store.commit("getProductCode");
      this.$router.push({ path: "/collection/product/" + this.routeParamArtworkId});
    },
  },

  created: function() {
    this.$parent.headerNoBg();
    this.$parent.footerB();
    this.$parent.footerW();
    this.$store.state.current_step = 5;
    this.type = this.$store.state.artwork.type;
    this.format = this.$store.state.artwork.format;
    this.layout = this.$store.state.artwork.layout;
    this.rightLayout = this.$store.state.artwork.rightLayout;
    this.tripleRightLayout = this.$store.state.artwork.tripleRightLayout;
  },
  computed: {
    label1() {
      return (this.$store.getters.isVertical) ? 'TOP SIDE' : 'LEFT SIDE';
    },
    label2() {
      if (this.format == 'double') {
        return 'RIGHT SIDE';
      } else if (this.$store.getters.isTriple) {
        return 'CENTER';
      } else if (this.format == 'vdouble') {
        return 'BOTTOM SIDE';
      }
      return '';
    },
    label3(){
      if (this.$store.getters.isVertical) {
        return 'BOTTOM SIDE';
      }
      return 'RIGHT SIDE';
    },
    layoutStyle: {
      get: function() {
        return this.$store.state.artwork.layoutStyle;
      },
      set: function(newValue) {
        this.$store.state.artwork.layoutStyle = newValue;
        this.$store.state.artwork.alignment = "topleft";
        
        var iconAndFontSize = this.$store.state.iconFontMap[this.type][newValue]
        if (iconAndFontSize.hasIconSize) {
          this.$store.state.artwork.iconSize = iconAndFontSize.iconSize[0].label;
        }
        if (iconAndFontSize.hasFontSize) {
          this.$store.state.artwork.fontSize = iconAndFontSize.fontSize[0].label;
        }
        this.$store.commit("getContent");
      },
    },
    rightLayoutStyle: {
      get: function() {
        return this.$store.state.artwork.rightLayoutStyle;
      },
      set: function(newValue) {
        this.$store.state.artwork.rightLayoutStyle = newValue;
        (this.$store.state.artwork.rightAlignment = "topleft");

        var iconAndFontSize = this.$store.state.iconFontMap[this.type][newValue]
        if (iconAndFontSize.hasIconSize) {
          this.$store.state.artwork.rightIconSize = iconAndFontSize.iconSize[0].label;
        }
        if (iconAndFontSize.hasFontSize) {
          this.$store.state.artwork.rightFontSize = iconAndFontSize.fontSize[0].label;
        }
        this.$store.commit("getRightContent");
      },
    },
    tripleRightLayoutStyle: {
      get: function() {
        return this.$store.state.artwork.tripleRightLayoutStyle;
      },
      set: function(newValue) {
        this.$store.state.artwork.tripleRightLayoutStyle = newValue;
        (this.$store.state.artwork.tripleRightAlignment = "topleft");

        var iconAndFontSize = this.$store.state.iconFontMap[this.type][newValue]
        if (iconAndFontSize.hasIconSize) {
          this.$store.state.artwork.tripleRightIconSize = iconAndFontSize.iconSize[0].label;
        }
        if (iconAndFontSize.hasFontSize) {
          this.$store.state.artwork.tripleRightFontSize = iconAndFontSize.fontSize[0].label;
        }
        this.$store.commit("getTripleRightContent");
      },
    },
  },
  beforeRouteEnter(to, from, next) {
      next(vm => {
        if (!vm.$data.type) {
          alert("Please go to the start page");
          vm.$router.push({ path: "/collection/" });
          return;
        }
        if (vm.$data.format == "single" && vm.$data.styleSet[vm.$data.type][vm.$data.layout].length == 0) {
          if (from.name == 'collection-engraving') {
            vm.$router.push({ path: "/collection/product/" + (vm.$route.params.aid || '')});
          } else if (from.name == 'collection-product') {
            vm.$router.push({ path: "/collection/engraving/" + (vm.$route.params.aid || '')});
          }
        }
      });
  },
}
</script>

<style lang="css" scoped>
.nav-footer{
  border-top:1px solid #ccc;
}
</style>
